import appConfig from 'app-config';

const DEEPLINK_SCHEME = 'azarlive://';

export const DEEPLINK_FRAGMENT_PATH = {
  GENDER: 'gender',
  SHOP: 'shop',
  MESSAGES: 'messages',
  FOLLOWING: 'following',
  FOLLOWER: 'follower',
  SUBS_POPUP: 'subs_popup',
  VIEWED_ME: 'viewed_me',
  PROFILE_VIEWER: 'profile_viewer', // viewed_me의 legacy 대응 https://hpcnt.slack.com/archives/C01BHEXJS3Z/p1777448715006549?thread_ts=1777369838.381639&cid=C01BHEXJS3Z
  MY_PROFILE: 'my_profile',
  HISTORY: 'history',
  RECENT_ACTIVITY: 'recent_activity',
  PWA_GUIDE: 'pwa-guide',
} as const;

/**
 * azarlive:// 딥링크를 URL hash fragment로 변환한다.
 * e.g. "azarlive://following?filter=online" → "following?filter=online"
 *
 * Vividi 전용 딥링크(GENDER 등)는 Azar 빌드에서 null을 반환한다.
 */
export function deeplinkToFragment(deeplink: string): string | null {
  if (!deeplink.startsWith(DEEPLINK_SCHEME)) return null;
  const fragment = deeplink.slice(DEEPLINK_SCHEME.length);
  const fragmentPath = fragment.split('?')[0];
  if (appConfig.serviceCode !== 'vividi' && fragmentPath === DEEPLINK_FRAGMENT_PATH.GENDER) {
    return null;
  }
  return fragment;
}

export { DEEPLINK_SCHEME };
